<template>
	<div class="modal fade xkit-modal" tabindex="-1" :id="'xkit-modal-' + wrapper_id">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title"></h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					...loading
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import  { useModalStore } from "../stores/store-modal.js";
import {onMounted} from "vue";

let $ = jQuery;
const props = defineProps({
	state: Object,
	wrapper_id: String,
})

const store = useModalStore()

let $modal = null

onMounted(function(){
	$modal = $( '.xkit-modal', '#' + props.wrapper_id)

	store.modals[ props.wrapper_id ] = {
		state: props.state,
		html: null,
	}
	// $( '.xkit-modal', '#' + props.wrapper_id).dialog({
	// 	autoOpen: false,
	// 	title: props.state.title,
	// 	dialogClass: "xkit",
	// 	position: { my: "top", at: "top+5%", of: window, collision: 'fit' },
	// 	width: 'auto',
	// });

	$( '.modal-title', $modal).html( props.state.title )

	$modal.on('click', '[data-xkit-close-modal]', function(e) {
		e.preventDefault()
		bootstrap.Modal.getOrCreateInstance($modal[0]).hide()
	})

	$modal.on('click', '[data-xkit-submit-modal]', function(e) {
		e.preventDefault()
		store.submit_modal( props.wrapper_id, e )
	})
})
</script>